var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"side-menu"},_vm._l((_vm.subMenuData),function(menu){return _c('div',{key:menu.code,class:menu.code === _vm.currentValue
                ? 'side-menu-item selected'
                : 'side-menu-item',on:{"click":function($event){return _vm.togleMenu(menu)}}},[_c('div',{staticClass:"side-menu-item-icon"},[_c('img',{attrs:{"src":menu.img ? `${'https://' + menu.img}` : _vm.defaultIcon}})]),_c('div',{staticClass:"side-menu-item-text"},[_vm._v(_vm._s(menu.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }